import { css } from 'react-emotion';
import { fonts, colors } from '@peachjar/components';

const { prussian, platinum } = colors;
const { ProximaNova } = fonts;

const styles = {
  header: css`
    font-size: 34px;
    line-height: 42px;
    margin-bottom: 1rem;
    font-weight: 600;
    color: ${prussian};
    width: 100%;
  `,
  text: css`
    font-size: 16px;
    line-height: 21px;
    color: ${prussian};
    margin-bottom: 3rem;
    font-family: ${ProximaNova} !important;
  `,
  wrapper: css`
    width: 420px;
  `,
  svg: css`
    background-color: none;
    flex-grow: 1;
    width: 90%;
  `,
  mobileSvgWrapper: css`
    padding-bottom: 2rem;
  `,
  buttonWrapper: css`
    margin-left: -5px;
    margin-top: 3rem;
  `,
  input: css`
      width: 100%;
      font-family ${ProximaNova};
      margin-top: 2rem;
    `,
  whitespaceColumnBg: css`
    background-color: ${platinum};
  `,
};

export default styles;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff-password/containers/SetupStaffPasswordContainer.css.js